import React from 'react';

const LoadingScreen = ({ message = 'Carregando...' }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center p-4">
      <div className="text-center">
        {/* Animated Logo */}
        <div className="inline-block mb-8 animate-bounce-in">
          <div className="relative">
            {/* Pulse Ring */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-3xl opacity-20 animate-pulse"></div>
            
            {/* Main Icon */}
            <div className="relative p-8 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-3xl shadow-2xl">
              <svg className="w-20 h-20 text-white animate-float" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
          </div>
        </div>

        {/* Loading Text */}
        <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-3 animate-fade-in">
          Visão Tiss
        </h2>

        {/* Message */}
        <p className="text-gray-600 text-lg mb-8 animate-fade-in">
          {message}
        </p>

        {/* Loading Spinner */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-3 h-3 bg-indigo-600 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-3 h-3 bg-purple-600 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>

      </div>
    </div>
  );
};

export default LoadingScreen;